import React, { useEffect, useState, useMemo, useRef, useCallback} from 'react' 
import { useParams, useLocation } from 'react-router-dom';
import { Link, Route, Routes, useSearchParams } from 'react-router-dom';
import '../layout/ListProds.Module.css';
import { cate, prods } from '../prods';
import { material, ips } from '../filters';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from "react-router-dom";
import { useAuth } from './AuthContext';
import { useLanguage } from './LanguageContext';
import translateText from './translateText';
import {colors, getTranslatedColorName } from '../colors';
import axios from 'axios';
import { fetchBrands, fetchRecommendedProducts } from '../api';
import { ourBrands, reBrands } from '../brands'
import {addToRecentView } from './ProdDetail';
import ProductCard from './ProductCard'
const TranslateCategory = ({  }) => {
  const { category } = useParams();
  const { selectedLanguage } = useLanguage();

  const findCategoryTranslation = (brandsList) => {
    for (const brand of brandsList) {
      const foundCategory = brand.category.find((type) => type.name === category);
      if (foundCategory && foundCategory.nome[selectedLanguage]) {
        return foundCategory.nome[selectedLanguage]; 
      }
    }
    return null; // Retorna null se não encontrar tradução
  };

  // Buscar tradução primeiro na ourBrands, depois na reBrands
  let translatedCategory = findCategoryTranslation(ourBrands);
  if (!translatedCategory) {
    translatedCategory = findCategoryTranslation(reBrands);
  }

  return <h2 className='text-center category-name mt-5'>{translatedCategory || category}</h2>;
};

 function ListProdus(props) {
  const { selectedLanguage } = useLanguage();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
useEffect(() => {
  setLoadingProducts(true);
  fetch('https://backend-theta-gold-17.vercel.app/produtos')
    .then(res => res.json())
    .then(prod => setProducts(Array.isArray(prod) ? prod : []))
    .catch(console.error)
    .finally(() => setLoadingProducts(false));
}, []);

  const predefinedIps = [
    { ip: '20' }, { ip: '33' },
    { ip: '40' }, { ip: '42' },
    { ip: '44' }, { ip: '54' },
    { ip: '55' }, { ip: '65' },
    { ip: '66' }, { ip: '67' },
    { ip: '68' },{ ip: '69K' },
  ];
  const [listIps, setListIps] = useState(predefinedIps);
  const predefinedIks = [
    { ik: '04' },
    { ik: '06' },
    { ik: '07' },
    { ik: '08' },
    { ik: '10' },
  ];

  const handleColorChange = (e) => {
    const value = e.target.value;
    setSelectedColors((prev) =>
      prev.includes(value) ? prev.filter((color) => color !== value) : [...prev, value]
    );
  };

const [listIk, setListIks] = useState(predefinedIks);
const [brands, setBrand] = useState([])
useEffect(() => {
 fetchBrands().then(setBrand);
}, [brands]);

const [filteredData, setFilteredData] = useState([]);
const [selectedColors, setSelectedColors] = useState([]);
const [selectedBrands, setSelectedBrands] = useState([]);
const [selectedIps, setSelectedIps] = useState([]);
const [selectedIks, setSelectedIks] = useState([]);
const [selectedVolts, setSelectedVolts] = useState([]);
const [selectedPowerRanges, setSelectedPowerRanges] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);
const [mpages, setMpages] = useState([]);
const [includeNewProducts, setIncludeNewProducts] = useState(false);
const itemPerPage = 24; /*Items per page*/
const [loadingProducts, setLoadingProducts] = useState(true); // loading da fetch geral
const [loadingSearch, setLoadingSearch] = useState(false); // loading da fetch searchItem
/*******************Usar paginação em 2 listas, dos clique e pesquisa********************* */
const { t, i18n } = useTranslation();
const location = useLocation();
const searchItem = searchParams.get('searchItem') || location.state || '';
const { brand, category} = useParams(); 
const [data, setData] = useState([]); 

const cache = useRef({});
useEffect(() => {
  const term = searchItem.trim();
  //Evita chamadas para buscas vazias
  if (!term) {
    setData([]);
    setLoadingSearch(false);
    return;
  }
  //Usa useRef como cache em memória durante a sessão atual, Se o termo já foi buscado anteriormente nessa sessão, a resposta é reutilizada instantaneamente sem nova chamada à API.
  if (cache.current[term]) {
    setData(cache.current[term]);
    setLoadingSearch(false);
    return;
  }

  const sessionResult = sessionStorage.getItem(`result-${term}`);
  if (sessionResult) {
    const parsed = JSON.parse(sessionResult);
    setData(parsed);
    cache.current[term] = parsed;
    setLoadingSearch(false);
    return;
  }
  //az o fetch apenas se não tiver cache
  setLoadingSearch(true);
  const startTime = Date.now();
  fetch(`https://backend-theta-gold-17.vercel.app/api/data2?searchItem=${encodeURIComponent(term)}`)
    .then(res => res.json())
    .then(result => {
      const clean = Array.isArray(result) ? result : [];
      setData(clean);
      //Salva os resultados no cache de memória e no sessionStorage
      cache.current[term] = clean;
      sessionStorage.setItem(`result-${term}`, JSON.stringify(clean));
    })
    .catch(err => {
      console.log(err);
      setData([]);
    })
    .finally(() => {
      const elapsed = Date.now() - startTime;
      const minDelay = 700;
      if (elapsed < minDelay) {
        setTimeout(() => setLoadingSearch(false), minDelay - elapsed);
      } else {
        setLoadingSearch(false);
      }
    });
}, [searchItem]);

function extractPowerValue(powerStr) {
  if (!powerStr || typeof powerStr !== 'string') return null;

  // Encontra todos os números (incluindo decimais)
  const matches = powerStr.match(/(\d+(\.\d+)?)/g);
  if (!matches || matches.length === 0) return null;

  // Converte em números e retorna o maior
  const numbers = matches.map(Number);
  return Math.max(...numbers);
}

const powerRanges = [
  { label: "0-5W", min: 0, max: 5 },
  { label: "6-10W", min: 6, max: 10 },
  { label: "11-20W", min: 11, max: 20 },
  { label: "21-50W", min: 21, max: 50 },
  { label: "51W+", min: 51, max: Infinity },
];

const [notFound, setNotFound] = useState(false);
useEffect(() => {
  let baseData = !searchItem.trim() ? products : data;
  if (!Array.isArray(baseData)) {
    setFilteredData([]);
    setNotFound(true);
    return;
  }

  let filtered = [...baseData];

  if (searchItem.trim()) {
    const searchNormalized = removeDiacritics(searchItem.toLowerCase());
    filtered = filtered.filter(item => {
      const itemName = removeDiacritics(item.nome?.toLowerCase() || "");
      const itemProdEspeArray = item.prodEspe ? item.prodEspe.split(",").map(s => s.trim().toLowerCase()) : [];
      return (
        itemName.includes(searchNormalized) ||
        itemProdEspeArray.some(prod => prod.includes(searchNormalized))
      );
    });
  }

  if (brand && category) {
    filtered = filtered.filter(item => item.marca === brand && item.nomeC === category);
  } else if (category) {
    filtered = filtered.filter(item => item.nomeC === category);
  } else if (brand) {
    filtered = filtered.filter(item => item.marca === brand);
  }

  // Remove duplicados
  const uniqueFiltered = filtered.filter((item, index, self) => 
    index === self.findIndex(t => t.idP === item.idP)
  );

  setFilteredData(uniqueFiltered);
  setNotFound(uniqueFiltered.length === 0);
  setCurrentPage(1);
}, [searchItem, brand, category, data, products]);

function removeDiacritics(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

useEffect(() => {
  setCurrentPage(1); // Reset to page 1 when selected filters change
}, [selectedColors, selectedIps, selectedIks, selectedVolts,selectedBrands]);

  // Update pagination details when filteredData or currentPage changes
  useEffect(() => {
    const filteredProducts = filterProducts();
    const newTotalPages = Math.ceil(filteredProducts.length / itemPerPage);
    setTotalPages(newTotalPages);
    const pagesToShow = 5;
    const halfPagesToShow = Math.floor(pagesToShow / 2);
    let startPage = Math.max(currentPage - halfPagesToShow, 1);
    let endPage = Math.min(startPage + pagesToShow - 1, newTotalPages);

    if (endPage - startPage < pagesToShow - 1) {
      startPage = Math.max(endPage - pagesToShow + 1, 1);
    }

    const newMpages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    setMpages(newMpages);
  }, [filteredData, currentPage, selectedColors, selectedIps,selectedIks, selectedVolts,selectedBrands]);

  const onPageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setSearchParams((prev) => {
        const params = new URLSearchParams(prev);
        params.set('page', page.toString());
        if (searchItem) {
          params.set('searchItem', searchItem);
        }
        return params;
      });
    }
  };

const uniqueFilteredData = filteredData.filter(
  (item, index, self) =>
    index === self.findIndex((t) => t.idP === item.idP)
);

useEffect(() => {
  const pageFromParams = parseInt(searchParams.get("page"), 10) || 1;
  setCurrentPage(pageFromParams);
}, [searchParams]);

const { user, toggleFavorite } = useAuth()

const filterProducts = () => {
  return filteredData.filter(product => {
    const matchesColor = selectedColors.length === 0 || selectedColors.includes(product.cor);
    const matchesBrands = selectedBrands.length === 0 || selectedBrands.includes(product.marca);
    const matchesIp = selectedIps.length === 0 || (product.ip !== null && selectedIps.includes(product.ip.toString()));
    const matchesIk = selectedIks.length === 0 || (product.ik !== null && selectedIks.includes(product.ik.toString()));
    const matchesVolt = selectedVolts.length === 0 || selectedVolts.includes(product.volt);
    const matchesNew = !includeNewProducts || product.novo === 1;

    const potenciaBruta = product.w || product.detalhes || product.descricao || "";

    const powerValue = extractPowerValue(potenciaBruta);
    const matchesPower =
      selectedPowerRanges.length === 0 ||
      (powerValue !== null &&
        selectedPowerRanges.some(label => {
          const range = powerRanges.find(r => r.label === label);
          return range && powerValue >= range.min && powerValue <= range.max;
        })
      );


    return matchesColor && matchesIp && matchesIk && matchesVolt && matchesBrands && matchesNew && matchesPower;
  });
};

const filteredProducts = filterProducts();
const lastIndexPage = currentPage * itemPerPage;
const firstItemPage = lastIndexPage - itemPerPage;
const listProds = useMemo(() => {
  return filteredProducts.slice(firstItemPage, lastIndexPage);
}, [filteredProducts, currentPage, itemPerPage]);
  return (
    <div className='listProds'> 

     <div className='container title-container'>
     <div className='name-category'> 
     <TranslateCategory category={category} />
         <h2 className='text-center brand-name text-uppercase'>{brand}</h2>
        </div>
     </div>

      <div className="container-xxl mx-auto m-4">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a className="text-decoration-none text-uppercase" href="/produtos">{t('homepage.produtos')}</a></li>
          <li className="breadcrumb-item active text-uppercase" aria-current="page">{t('listProds.pesqui')}</li>
        </ol>
      </nav>

        <div className="d-flex justify-content-between align-items-md-center mb-3 py-2 py-lg-0 prod-list-top-btns">
          <div className="dropdown btn-open-filters">
            <button className="btn btn-secondary open-filters hide-filterbutton mr-auto fw-bold text-uppercase" data-bs-toggle="offcanvas" href="#prodFilters" role="button" aria-controls="prodFilters">{t('listProds.filtrar')}</button>
          </div>
        </div>

        <div className="row">
        <div className="col-12 col-md-3 col-xl-2 prod-list-filter-wrapper offcanvas offcanvas-start" tabIndex={-1} id="prodFilters" aria-labelledby="prodFilters">
            <div className="offcanvas-header d-lg-none pe-0">
              <button className="btn ms-auto px-3" type="button" data-bs-dismiss="offcanvas" aria-label="Close"><i className="fa-solid fa-backward" /></button>
            </div>
          <div className="offcanvas-body p-3 pt-2 pb-3">
          <div className="filter-block">

            <form className="shop__filter">
              <h4 className="block_title">{t('listProds.filtrarpor')}</h4>      
              <div className="filter-block">

              <button className="filter-title headline collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#filterMarcas" aria-expanded="false" aria-controls="filterMarcas">{t('navbar.marcas')}</button>
              <div className="prod-list-filter-list collapse show" id="filterMarcas">
                <div className="custom-scroll">
                  {ourBrands.map((item, index) => (
                    <label className="material-checkbox text-uppercase" key={index}>
                      <input  type="checkbox" id={item.name}  value={item.name}
                        onChange={(e) => { const value = e.target.value;
                          setSelectedBrands(prev => prev.includes(value) ? prev.filter(name => name !== value) : [...prev, value]
                          ); }} />
                      <span className="checkmark text-uppercase"></span> {item.name} </label>
                  ))}
                  {reBrands.map((item, index) => (
                    <label className="material-checkbox text-uppercase" key={index}>
                      <input  type="checkbox" id={item.name}  value={item.name}
                        onChange={(e) => { const value = e.target.value;
                          setSelectedBrands(prev => prev.includes(value) ? prev.filter(name => name !== value) : [...prev, value]
                          ); }} />
                      <span className="checkmark text-uppercase"></span> {item.name} </label>
                  ))}
                </div>
              </div>
              </div>

              <hr className="card-line w-100" />
              <button className="filter-title collapsed headline" type="button" data-bs-toggle="collapse" data-bs-target="#filterNovo" aria-expanded="false" aria-controls="filterNovo">{t('pdetail.potencia')}(W)</button>
                <div className="prod-list-filter-list collapse" id="filterNovo">
                <div className="custom-scroll">
                {powerRanges.map((range, index) => (
                  <label className="material-checkbox" key={index}>
                    <input type="checkbox" value={range.label}
                      checked={selectedPowerRanges.includes(range.label)}
                      onChange={(e) => {const value = e.target.value; setSelectedPowerRanges(prev => prev.includes(value) ? prev.filter(r => r !== value)  : [...prev, value]
                        );
                      }} />
                    <span className="checkmark"></span> {range.label}
                  </label>
                ))}
                </div>
              </div>

              <hr className="card-line w-100" />
              <button className="filter-title collapsed headline" type="button" data-bs-toggle="collapse" data-bs-target="#filterIp" aria-expanded="false" aria-controls="filterIp">IP</button>
                <div className="prod-list-filter-list collapse" id="filterIp">
                <div className="custom-scroll">
                {listIps.map((item, index) => (
                    <label className="material-checkbox " key={index}>
                      <input  type="checkbox" id={item.ip}  value={item.ip.toString()}
                        onChange={(e) => {const value = e.target.value;
                          setSelectedIps(prev =>
                            prev.includes(value) ? prev.filter(ip => ip !== value) : [...prev, value]
                          ); }} />
                      <span className="checkmark"></span> {item.ip}
                    </label>
                  ))}
                </div>
              </div>

              <hr className="card-line w-100" />
              <button className="filter-title collapsed headline" type="button" data-bs-toggle="collapse" data-bs-target="#filterIK" aria-expanded="false" aria-controls="filterIK">IK</button>
              <div className="prod-list-filter-list collapse" id="filterIK">
                <div className="custom-scroll">
                {listIk.map((item, index) => (
                    <label className="material-checkbox " key={index}>
                      <input  type="checkbox" id={item.ik}  value={item.ik.toString()}
                        onChange={(e) => { const value = e.target.value;
                          setSelectedIks(prev => prev.includes(value) ? prev.filter(ip => ip !== value) : [...prev, value]
                          );
                        }} />
                      <span className="checkmark"></span> {item.ik}
                    </label>
                  ))}
                </div>
              </div>

              <hr className="card-line w-100" />
              <div className="filter-block ">
                    <button className="filter-title collapsed headline" type="button" data-bs-toggle="collapse" data-bs-target="#filtercor" aria-expanded="false" aria-controls="filtercor">{t('listProds.novo')}</button>
                <div className="prod-list-filter-list collapse" id="filtercor">
                      <div className="custom-scroll colorList">
                      <label className="material-checkbox filter-field">
                      <input type="checkbox" checked={includeNewProducts} onChange={(e) => setIncludeNewProducts(e.target.checked)}/>
                      <span className="checkmark"></span>
                      {t('listProds.novo')}
                    </label>
                      </div>
                </div>
              </div>

              <hr className="card-line w-100" />
              <button className="filter-title collapsed headline" type="button" data-bs-toggle="collapse" data-bs-target="#filterCor" aria-expanded="false" aria-controls="filterCor">{t('pdetail.cor')}</button>
              <div className="prod-list-filter-list collapse" id="filterCor">
            <div className="custom-scroll colorList">
            {colors.map((item, index) => (
                <label className="material-checkbox" key={index}>
                  <input  type="checkbox" id={item.cor}  value={item.cor}
                    onChange={(e) => { handleColorChange(e)}}/>
                  <span className=" checkmark"></span>
                  {getTranslatedColorName(item.cor, i18n.language)}
                </label>
              ))}
            </div>
              </div>
            </form>
           </div>
         
          </div>
          </div>

          <div className="col-lg-8 col-md-12">
            <ul className="shop__sorting">
                <li className="number-prods"><span><b>{filteredProducts.length}</b> {t('homepage.produtos')}</span></li>
                <li><span ><></></span></li>
              </ul>
            <div className="row">
                {(loadingProducts || loadingSearch) ? (
                  <div className="containe">
                    <div className="box loading">
                      <div className="content">
                        <div className="loading-dots">
                          <h1 className='mb-3'>{t('pdetail.carregando')}</h1>
                          <div className="loading-dots--dot"></div>
                          <div className="loading-dots--dot"></div>
                          <div className="loading-dots--dot"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                    ) : notFound ? (
                      <div className="col-12 text-center">
                        <h4 className="text-muted">{t('listProds.nexiste')} {searchItem}</h4>
                      </div>
                  ) : (
                  listProds.map((resu, index) => {
                    return (
                      <div className="col-sm-6 col-lg-3 col-md-3 col-6 product-card" key={index}>
                        <ProductCard resu={resu} toggleFavorite={toggleFavorite} addToRecentView={addToRecentView} t={t} />
                      </div>
                    );
                  })
                )}
            </div> {/* / .row */}
          </div> {/* / .col-sm-8 */}
        </div> {/* / .row */}
      </div>

      <div className='center-pagination'>
            <section className="pagination-section p-5 p-2 bd-highlight mb-3">
            <ul className="pagination-prods">
            <li>
            <button id="pg-button-prev" type="button" className="pagination__button" 
            onClick={()=>onPageChange(currentPage-1)} disabled={currentPage ===1}>
              <i className="fa fa-chevron-left" />
            </button>
            </li>
            {mpages[0] > 1 && (
              <>
                <button className='pagination__button_ellipses' onClick={() => onPageChange(1)}>1</button>
                {mpages[0] > 2 && <span className='pagination__button_ellipses'>...</span>}
              </>
            )}
            {mpages.map((page, index) => (
              <li className={page === currentPage ? 'active' : ''} key={index}
                onClick={() => onPageChange(page)}>
                <button id="pg-button-1" type="button">{page}</button>
              </li>
            ))}
            {mpages[mpages.length - 1] < totalPages && (
              <>
                {mpages[mpages.length - 1] < totalPages - 1 && <span className='pagination__button_ellipses'>...</span>}
                <button className='pagination__button_ellipses' onClick={() => onPageChange(totalPages)}>{totalPages}</button>
              </>
            )}
              <li>
            <button id="pg-button-next" type="button" className="pagination__button" 
              onClick={()=>onPageChange(currentPage+1)} disabled={currentPage === totalPages}>
              <i className="fa fa-chevron-right" />
            </button>
            </li>

            </ul>
          </section>
      </div>
    </div>
  )
}

export default ListProdus
 
